import React from 'react';

// project-imports
import StencilBox from '../stencils/StencilBox';

const ConsultationCallToActionStencil = () => {

    return (

        <div className="edu-accordion-area eduvibe-home-three-accordion about-style-2 accordion-shape-1 edu-section-gap bg-color-white bg-stencil-newsletter">
            <div className="container eduvibe-animated-shape">
                <div className="row g-5 align-items-center">
                    <div className="col-12 col-xl-6">
                        <div className="inner">
                            <div>
                                <StencilBox
                                    className="newsletter-stencil-title mb--10 stencil-display-inline-block"
                                    width="270px"
                                    height="26px"
                                    backgroundColor="#F5F5F5"
                                />
                            </div>
                            <StencilBox
                                className="stencil-display-inline-block"
                                width="50%"
                                height="30px"
                                backgroundColor="#F5F5F5"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-xl-6">
                        <div className="newsletter-right-content d-block d-md-flex align-items-center justify-content-start justify-content-xl-end">
                           <div className="load-more-btn">
                                <StencilBox
                                    className="newsletter-stencil-btn edu-btn stencil-display-inline-block"
                                    width="360px"
                                    height="60px"
                                    backgroundColor="#F5F5F5"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConsultationCallToActionStencil;